import type { WithActiveBranchId } from '../shared';

export enum AiPromptsEndpoints {
  Get = 'GetAiPrompts',
  Save = 'SaveAiPrompts',
  GetDefault = 'GetDefaultAiPrompt',
}

export interface ModelAiPrompt {
  Key: string | null;
  Title: string | null;
  Content: string | null;
}

export type GetAiPromptsRequest = WithActiveBranchId;
export type GetAiPromptsResponse = ModelAiPrompt[];

export type SaveAiPromptsRequest = WithActiveBranchId<{
  data: ModelAiPrompt[];
}>;
export type SaveAiPromptsResponse = void;

export type GetDefaultAiPromptRequest = WithActiveBranchId<{
  promptKey: string;
}>;
export type GetDefaultAiPromptResponse = string;
